import {
	ICustomerVehicle,
	ILineItemOption,
	ILineItemOptionChoice,
	IMenu,
	IPickupDetails,
	ITicketSubmit,
	IVehiclePropertyBase,
	IVehiclePropertyColor,
	SERVICE_TYPE,
} from '../../store';

// import JSON files
// TODO: replace with a smarter object builder
import * as responseMenu from './response-menu.json';

class Factory {
	vehiclePropBase(): IVehiclePropertyBase {
		return {
			propertyId: '',
			priority: 0,
			value: ''
		};
	}

	vehiclePropColor(): IVehiclePropertyColor {
		return {...this.vehiclePropBase(), hexValue: ''};
	}

	customerVehicle(franchisorBase = ''): ICustomerVehicle {
		return {
			customerVehicleId: '',
			franchisorBase: franchisorBase,
			color: this.vehiclePropColor(),
			make: this.vehiclePropBase(),
			type: this.vehiclePropBase()
		};
	}

	lineItemOption(): ILineItemOption {
		return {
			name: 'Factory Options',
			exclusive: false,
			required: false,
			freeChoicesCount: 0,
			priority: 30,
			maxChoices: 0,
			minChoices: 0,
			isMasterOption: false,
			isContainerOption: false,
			alwaysShowOnKds: false,
			forceHideDeselectedChoices: false,
			mobileInline: false,
			choices: [
				this.lineItemOptionChoice(),
			],
			optionId: 'f154',
			hideInApp: false
		};
	}

	lineItemOptionChoice(): ILineItemOptionChoice {
		return {
			name: 'Factory Choice',
			mobileTitle: '',
			mobileSubtitle: '',
			included: false,
			includedQuantity: 0,
			excluded: false,
			price: 0,
			maxQuantity: 3,
			fractionalQuantity: 0,
			maxFractionalQuantity: 0,
			mutableQuantity: true,
			isUserSet: false,
			containerImage: null,
			image: null,
			lineItem: null,
			choiceId: '9001',
			selected: false,
			quantity: 0,
			hideInApp: false
		};
	}

	menu(): IMenu {
		return responseMenu.data.menu as unknown as IMenu;
	}

	pickupDetails(): IPickupDetails {
		return {
			vehicle: null,
			curbsideLocation: null,
			note: ''
		};
	}

	ticketSubmit(): ITicketSubmit {
		return {
			items: [],
			orderNotes: '',
			payments: null,
			pickupTime: 0,
			serviceType: SERVICE_TYPE.PICKUP,
			idempotencyToken: null,
			meta: {}
		};
	}
}

export const FactoryService = new Factory();
